import api from './api';
import type { Coupon, CreateCouponData, UpdateCouponData } from '../types';

export const couponService = {
  async getCoupons(): Promise<Coupon[]> {
    const response = await api.get<Coupon[]>('/company/coupons');
    return response.data;
  },

  async getCouponById(id: string): Promise<Coupon> {
    const response = await api.get<Coupon>(`/company/coupons/${id}`);
    return response.data;
  },

  async createCoupon(data: CreateCouponData): Promise<Coupon> {
    const response = await api.post<Coupon>('/company/coupons', data);
    return response.data;
  },

  async updateCoupon(id: string, data: UpdateCouponData): Promise<Coupon> {
    const response = await api.patch<Coupon>(`/company/coupons/${id}`, data);
    return response.data;
  },

  async deleteCoupon(id: string): Promise<void> {
    await api.delete(`/company/coupons/${id}`);
  },
};
